import React, { createContext, useContext } from 'react';
import useUserApi from '../../../../api/api/useUserApi';
import { EngineOilTestDto } from '../../../api';

interface UserDataContextProps {
    engineOilTests: EngineOilTestDto[] | null;
    isEngineOilTestsFetching: boolean;
}

const UserDataContext = createContext<UserDataContextProps | undefined>(undefined);

export function UserDataProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const { userEngineOilTestApi } = useUserApi();
    const { engineOilTests, isEngineOilTestsFetching } = userEngineOilTestApi;

    return (
        <UserDataContext.Provider value={{ engineOilTests, isEngineOilTestsFetching }}>
            {props.children}
        </UserDataContext.Provider>
    );
}

export const useUserDataContext = () => {
    const context = useContext(UserDataContext);
    if (!context) {
        throw new Error('useUserDataContext must be used within a UserDataProvider');
    }
    return context;
};
